import { getCmsUrl, getBackendUrl } from './configService';

/**
 * Rewrite a CMS file/image URL to route through the EM3 backend's
 * /api/cms-files proxy. The proxy attaches a Bearer token server-side so
 * the browser doesn't need a cross-origin Drupal session cookie to load
 * private files.
 *
 * Accepts:
 *   - Absolute URLs pointing at CMS_URL (e.g. https://cms…/sites/default/files/x.jpg)
 *   - Absolute paths (e.g. /sites/default/files/x.jpg)
 *
 * Returns the original value for anything else (external CDNs, data URIs, etc.)
 * so pass-through is safe.
 */
export function proxyCmsUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  const cmsUrl = (getCmsUrl() || '').replace(/\/+$/, '');
  const backendUrl = getBackendUrl() || '';

  let path: string;
  if (cmsUrl && url.startsWith(cmsUrl)) {
    path = url.slice(cmsUrl.length);
  } else if (url.startsWith('/')) {
    path = url;
  } else {
    // Drupal sometimes returns absolute URLs built from its Host header.
    // When the EM3 backend calls JSON:API via the internal network, that
    // host is an internal Docker alias like `cms-nginx` which the browser
    // can't resolve. Strip the host and route via the proxy.
    try {
      const parsed = new URL(url);
      if (parsed.hostname.startsWith('cms-')) {
        path = parsed.pathname + parsed.search + parsed.hash;
      } else {
        return url; // external URL, data URI, etc.
      }
    } catch {
      return url;
    }
  }
  return `${backendUrl}/api/cms-files${path}`;
}
